import React from 'react';
import ensureCartElements from '@sprinx/pricing-core/ensureCartElements';
export default function useCreateCart(cartPrototype) {
  return React.useMemo(function () {
    return ensureCartElements(cartPrototype);
  }, [cartPrototype]);
}